/** */
import {
  ADD_MANY_EFFECT_TO_STORE,
  ADD_ONE_EFFECT_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  REMOVE_MANY_EFFECT_FROM_STORE,
  REMOVE_ONE_EFFECT_FROM_STORE,
  UPDATE_ONE_EFFECT_IN_STORE
} from '../actions/effect';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_EFFECT_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (effects, effect) => ({
            ...effects,
            [effect.id]: effect
          }),
          {}
        )
      };

    case REMOVE_MANY_EFFECT_FROM_STORE:
      previous_state = { ...state };
      payload.forEach((id) => delete previous_state[id]);
      return {
        ...previous_state
      };

    case REMOVE_ONE_EFFECT_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };

    case ADD_ONE_EFFECT_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };

    case UPDATE_ONE_EFFECT_IN_STORE:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload
        }
      };

    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (effects, effect) => ({
            ...effects,
            [effect.id]: effect
          }),
          {}
        )
      };

    default:
      return state;
  }
};
